const LINK_PROPS = {
  link: {
    type: Object,
    required: true
  },
  imageStyle: String,
  btnSize: String,
  variant: String
};
export { LINK_PROPS };